'use strict';

import Utility from "@/Common/Utility";
import ElementDragger from "@/Common/ElementDragger";


function ListElementDragger() {

    this.Config = {
    };

    this.mosueDown = false;
    this.DraggingState = "Ready";
    this.PositionChanged = false;
    this.SourceIndex = 0;
    this.CanMoveX = true;
    this.CanMoveY = true;
    this.elementDragger = new ElementDragger();
    this.TargetListId = "";

    this.Attach = function (
        config
    ) {
        /*
        config = {
            ContainerElement: null,
            ContainerElementSelector:"",
            ToDragElementSelector: "",
            GetToDragElementRectHandler : null ,
            TargetList : [] ,
            DragHandleSelector: "",
            InjectEvent: function (
                resetHanlder,
                destroyHandler
            ) {

            }
        }
        */ 

        this.ContainerElement = config.ContainerElement;
        this.ListElementContainerId = config.ListElementContainerId;
        this.ContainerElementSelector = config.ContainerElementSelector;
        this.ToDragElementSelector = config.ToDragElementSelector;
        this.TargetList = config.TargetList;
        this.DragHandleSelector = config.DragHandleSelector;
        this.GetToDragElementRectHandler = config.GetToDragElementRectHandler;
        this.TargetListChangeHandler = config.TargetListChangeHandler;
        this.DropHandler = config.DropHandler;
         
        this.TargetList.UniqueId = Utility.GenerateUniqueId();
        this.TargetListId = this.TargetList.UniqueId;

        if (this.ListElementContainerId != null) {
            this.ContainerElement = document.querySelector(`[ListElementContainerId='${this.ListElementContainerId}']`);

            if (this.ContainerElement == null) {
                throw (`Can not find ContainerElement with ListElementContainerId='${this.ListElementContainerId}`);
            }
        }
        else if (
            this.ContainerElement != null &&
            (this.ListElementContainerId = this.ContainerElement.getAttribute("ListElementContainerId")) == null) {
            let uniqueId;

            uniqueId = Utility.GenerateUniqueId("ListElementContainerId");

            this.ListElementContainerId = uniqueId;
            this.ContainerElement.setAttribute("ListElementContainerId", uniqueId)
        }

        if (this.ContainerElement == null) {
            throw ("this.ContainerElement  is null");
        }

 

        if (config.CanMoveX != null) {
            this.CanMoveX = config.CanMoveX;
        }

        if (config.CanMoveY != null) {
            this.CanMoveY = config.CanMoveY;
        }

        if (config.InjectEvent != null) {
            config.InjectEvent(
                this.OnReset,
                this.OnDestroy
            );
        }

        this.Reset(this.TargetList);


        ListElementDragger.AllDraggers.push(this);
    };


  

    this.OnMouseMove = function (dragHandleElement, containerElement , targetList, toDragSelector) {

        
        if (
            this.ContainerElement != null &&
            this.ContainerElement != containerElement) {
            this.DraggingState = "Ready";

            if (this.ContainerElement != null) {
                this.ClearEvents();
            }

            this.Attach(
                {
                    ContainerElement: containerElement,
                    ToDragElementSelector: toDragSelector,
                    DragHandleSelector: null,
                    TargetList: targetList
                }
            );

            this.ToDragHandleElements.length = 0;

            this.ToDragHandleElements.push(dragHandleElement);
        }
        else if (this.ContainerElement == null) {

            this.Attach(
                {
                    ContainerElement: containerElement,
                    ToDragElementSelector: toDragSelector,
                    DragHandleSelector: null,
                    TargetList: targetList
                }
            );

            this.ToDragHandleElements.length = 0;

            this.ToDragHandleElements.push(dragHandleElement);
        }
        
   

      //  this.ClearEvents();
    };

    this.ContainerElement = null;
    this.ToDragElementSelector = "";
    this.DragHandleSelector = "";

    //會被拖曳的物件 必須是 Array
    this.ToDragElements = [];

    //會被拖曳的 DragHandle 物件 必須是 Array
    this.ToDragHandleElements = [];

    //會改變順序的物件 必須是個 Array
    this.TargetList = [];

    this.Reset = function (targetList) {
        let i;

        if (this.ListElementContainerId != null) {
            this.ContainerElement = document.querySelector(`[ListElementContainerId='${this.ListElementContainerId}']`);

            if (this.ContainerElement == null) {
                console.log(`Container with ListElementContainerId = '${this.ListElementContainerId}'  doesn't exists !`);
                return;
            }
        }

        this.ToDragElements = this.ContainerElement.querySelectorAll(this.ToDragElementSelector);

        if (targetList != null) {
            this.TargetList = targetList;
        }

        this.ToDragHandleElements.length = 0;

        for (i = 0; i < this.ToDragElements.length; i++) {
            let toDragHandleElement = null;

            if (this.DragHandleSelector == null) {
                toDragHandleElement = this.ToDragElements[i];
            }
            else {
                if (this.ToDragElements[i].matches(this.DragHandleSelector)) {
                    toDragHandleElement = this.ToDragElements[i];
                }
                else {
                    toDragHandleElement = this.ToDragElements[i].querySelector(this.DragHandleSelector);
                }
            }

            if (toDragHandleElement != null) {

                if (toDragHandleElement.tagName == "IMG") {
                    toDragHandleElement.setAttribute("draggable", "false");
                }

                this.ToDragHandleElements.push(toDragHandleElement);
            }
            else {
                this.ToDragHandleElements.push(document.createElement("DIV"));
            }
        }

        this.ClearEvents();
        this.BindEvents();
    };


    this.OnReset = function (targetList) {
        this.Reset(targetList);
    };


    //#region Window Events
    this.OnDragHandleSelectStart = function (e) {
        e.preventDefault();
        return false;
    }.bind(this);

    this.OnDragHandleMouseDown = function (e) {
        this.mouseDown = true;
    }.bind(this);

    this.OnDragHandleMouseUp = function (e) {
        
        this.OnDrop(e);
    }.bind(this);

    this.OnDragHandleDoubleClick = function (item) {
    }.bind(this);

    this.OnDragHandleMouseMove = function (e) {


        if (this.mouseDown) {
            if (this.DraggingState == "Ready") {

                this.OnDragHandleDragStart(e);

                this.DraggingState = "Dragging";
            }
            else if (this.DraggingState == "Dragging") {
                this.OnDragging(e);

                Utility.SaveSession("Dragging", true);
            }
        }
    }.bind(this);
    //#endregion


    this.GetToDragElement = function (element) {
        let parentElement = null

        parentElement = element;

        if (this.ToDragElements == null) {
            debugger;
            return null;
        }

        while (true) {

            if (Array.prototype.indexOf.call(this.ToDragElements, parentElement) >= 0) {
                break;
            }
            else {
                parentElement = parentElement.parentElement;

                if (parentElement.tagName == "BODY") {
                    parentElement = null;
                    break;
                }
            }
        }

        return parentElement;
    };

    //#region Dragging Handlers
    this.OnDragHandleDragStart = function (e) {
        let toDragElement = null;
        let rect = {};
        let x, y, width, height;
        let tempDragElement = null;
        let tempImgElement = null;
        let minX, maxX = 1000;
        let minY, maxY = 1000;



        this.ToDragElements = this.ContainerElement.querySelectorAll(this.ToDragElementSelector);
        if (this.ToDragElements == null) {
            debugger;
        }

        toDragElement = this.GetToDragElement(e.target);
        this.ToDragElement = toDragElement;
        this.OnReset(this.TargetList);


        this.PositionChanged = false;
        this.SourceIndex = Array.prototype.indexOf.call(this.ToDragElements, toDragElement);

        if ((tempDragElement = document.getElementById("TempDragElement")) == null) {

            tempImgElement = document.createElement("IMG");

            tempDragElement = document.createElement("DIV");
            tempDragElement.style.position = "absolute"
            tempDragElement.style.border = "2px solid #333333";
            tempDragElement.style.backgroundColor = "rgba(255,255,255,0.2)";
            tempDragElement.id = "TempDragElement";
            tempDragElement.style.zIndex = 3;
            tempDragElement.style.cursor = "move";
            tempDragElement.appendChild(tempImgElement);
            document.body.insertAdjacentElement("BeforeEnd", tempDragElement);

            tempDragElement = document.getElementById("TempDragElement");

            tempDragElement.addEventListener("mouseup", this.OnDragHandleMouseUp.bind(this));
        }


        //tempDragElement.style.backgroundImage = "url(" + toDragElement.querySelector("IMG").src + ")";
        //tempImgElement = tempDragElement.children[0];
        //tempImgElement.src = toMoveElement.querySelector("IMG").src;

        if (this.GetToDragElementRectHandler != null) {
            rect = this.GetToDragElementRectHandler(toDragElement);

            x = rect.left;
            y = rect.top;
            width = rect.width;
            height = rect.height;
        }
        else {
            x = Utility.GetClientLeft(toDragElement);
            y = Utility.GetClientTop(toDragElement);
            width = toDragElement.offsetWidth;
            height = toDragElement.offsetHeight;
        }

        tempDragElement.style.left = x + "px";
        tempDragElement.style.top = y + "px";
        tempDragElement.style.width = width + "px";
        tempDragElement.style.height = height + "px";
        tempDragElement.style.display = "block";


        minX = Utility.GetClientLeft(toDragElement.parentElement) - 20;
        maxX = minX + this.ContainerElement.getBoundingClientRect().width + 40;
        //maxX = Utility.GetClientLeft(this.$refs.Element) + this.$refs.Element.clientWidth - tempDragElement.clientWidth + 20;

        //minY = Utility.GetClientTop(toDragElement.parentElement) - 20;
        minY = Utility.GetClientTop(this.ContainerElement) - 20;
        maxY = minY + this.ContainerElement.getBoundingClientRect().height + 40;

        //maxY = Utility.GetClientTop(this.$refs.Element) + this.$refs.Element.clientHeight - tempDragElement.clientHeight + 20;

        this.elementDragger.MinX = minX;
        this.elementDragger.MaxX = maxX;

        this.elementDragger.MinY = minY;
        this.elementDragger.MaxY = maxY;

        this.elementDragger.CanMoveX = this.CanMoveX;
        this.elementDragger.CanMoveY = this.CanMoveY;

        this.elementDragger.AttachAndDrag(tempDragElement, null, e);

        this.elementDragger.DropHandler = this.OnDrop.bind(this);
        this.elementDragger.DraggingHandler = this.OnDragging.bind(this);

        this.lastIndex = -1;

        this.SourceIndex = Array.prototype.indexOf.call(this.ToDragElements, toDragElement);
    }.bind(this);


    this.OnDragging = function (e) {
        let tempDragElement;
        let hoverItemElementRect;
        let rect, point;
        let i;
 

        if ((tempDragElement = document.getElementById("TempDragElement")) != null) {
            if (this.GetToDragElementRectHandler != null) {
                let boundRect;

                rect = {};

                boundRect = this.GetToDragElementRectHandler(this.ToDragElement);

                rect.top = tempDragElement.getBoundingClientRect().top + document.documentElement.scrollTop;
                rect.left = boundRect.left;
                rect.width = boundRect.width;
                rect.height = boundRect.height;
            }
            else {
                let boundRect;

                boundRect = tempDragElement.getBoundingClientRect();

                rect = {};


                rect.top = boundRect.top;
                rect.left = boundRect.left;
                rect.width = boundRect.width;
                rect.height = boundRect.height;

                rect.top += document.documentElement.scrollTop;
            }

            point = {};

            point.X = Math.round(rect.left + rect.width / 2);
            point.Y = Math.round(rect.top + rect.height / 2);
            //console.log(
            //    "tempDragElement.style.left=" + tempDragElement.style.left + " , " +
            //    "rect.left=" + Math.round(rect.left) + "\r\n" +
            //    "tempDragElement.style.top=" + tempDragElement.style.top + " , " +
            //    "rect.top=" + Math.round(document.documentElement.scrollTop+rect.top) + "\r\n"
            //);
     
            for (i = 0; i < this.ToDragElements.length; i++) {

                if (this.GetToDragElementRectHandler != null) {
                    hoverItemElementRect = this.GetToDragElementRectHandler(this.ToDragElements[i]);
                }
                else {
                    let boundRect;

                    hoverItemElementRect = {};
                    boundRect = this.ToDragElements[i].getBoundingClientRect();

                    hoverItemElementRect.top = boundRect.top;
                    hoverItemElementRect.left = boundRect.left;
                    hoverItemElementRect.width = boundRect.width;
                    hoverItemElementRect.height = boundRect.height;

                    hoverItemElementRect.top += document.documentElement.scrollTop  ;
                }


                let isInside = this.InsideRect(point, hoverItemElementRect);

                if (isInside) {
                    //console.log("isInside =" + isInside + ",i=" + i);
                }

                if (this.InsideRect(point, hoverItemElementRect)) {
 
                    //if (point.X < (hoverItemElementRect.left + hoverItemElementRect.width / 2)) {
                    //    //偏左
                    //    console.log("Left");

                    //    this.ItemElements[i].style.borderLeft = "1px solid blue";
                    //    this.ItemElements[i].style.borderRight = "";
                    //}
                    //else {
                    //    //偏右
                    //    console.log("Right");
                    //    this.ItemElements[i].style.borderLeft = "";
                    //    this.ItemElements[i].style.borderRight = "1px solid green";
                    //}

                    if (this.SourceIndex != i) {
                        let lastDraggingElement;
                         
                        this.MoveTargetListItem(this.SourceIndex, i);

                        this.SourceIndex = i;
                        //this.$forceUpdate();

                        this.ToDragElements = this.ContainerElement.querySelectorAll(this.ToDragElementSelector);

                        lastDraggingElement = this.ContainerElement.querySelector(".DraggingElement");

                        if (
                            lastDraggingElement != null &&
                            lastDraggingElement != this.ToDragElements[this.SourceIndex]
                        ) {
                            lastDraggingElement.classList.remove("DraggingElement");
                        }

                        if (lastDraggingElement != this.ToDragElements[this.SourceIndex]
                            ||
                            !this.ToDragElements[this.SourceIndex].classList.contains("DraggingElement")
                        ) {
                            this.ToDragElements[this.SourceIndex].classList.add("DraggingElement");
                        }
                         
                        this.PositionChanged = true;

                        break;
                    }
                    else {
                        if (!this.ToDragElements[this.SourceIndex].classList.contains("DraggingElement")) {
                            this.ToDragElements[this.SourceIndex].classList.add("DraggingElement");
                        }
                    }
                }
            }

        }
    }.bind(this);


    this.OnDrop = function (e) {
        let tempDragElement = null;
        let lastDraggingElement;
        let i;

        this.mouseDown = false;

        this.DraggingState = "Ready";

        lastDraggingElement = document.querySelector(".DraggingElement");

        if (lastDraggingElement != null) {
            lastDraggingElement.classList.remove("DraggingElement");
        }

        Utility.SaveSession("Dragging", false);

        if (this.elementDragger.ToMoveElement == null) {
            return;
        }

        tempDragElement = document.getElementById("TempDragElement");

        if (tempDragElement != null) {
            this.elementDragger.Detach(e.target);
            tempDragElement.style.display = "none";
        }

        this.SourceIndex = -1;
               
        if (this.DropHandler != null) {
            this.DropHandler();
        }

        if (this.PositionChanged) {
            //this.OnValueChange();
            //this.$emit("PositionChanged");
        }

        this.PositionChanged = false;

    }.bind(this);
    //#endregion



    //#region 將 Items 中的元素 搬移位置 從 fromIndex 移至 toIndex
    this.MoveTargetListItem = function (fromIndex, toIndex) {
        let toMoveItem = null;


        if (this.TargetList == null) {
            debugger;
        }

        toMoveItem = this.TargetList[fromIndex];


        this.TargetList.splice(fromIndex, 1);
        this.TargetList.splice(toIndex, 0, toMoveItem);


 
        if (this.TargetListChangeHandler != null) {
            this.TargetListChangeHandler(this.TargetList);
        }
    };
    //#endregion

    //#region Utility
    this.InsideRect = function (point, rect) {
        let inside = false;

        if (
            (rect.left <= point.X && point.X <= rect.left + rect.width) &&
            (rect.top <= point.Y && point.Y <= rect.top + rect.height)
        ) {
            inside = true;
        }

        return inside;
    };
    //#endregion


    this.ClearEvents = function () {
        let toDragHandleElement;
        let tempDragElement;
        let i;

        this.ContainerElement.setAttribute("HasBindListElementDraggerEvent", "true");

        for (i = 0; i < this.ToDragHandleElements.length; i++) {
            toDragHandleElement = this.ToDragHandleElements[i];

 

            //#region Remove Last Events
            toDragHandleElement.removeEventListener(
                "selectstart",
                this.OnDragHandleSelectStart.bind(this)
            );

            toDragHandleElement.removeEventListener(
                "mousedown",
                this.OnDragHandleMouseDown.bind(this)
            );

             
            toDragHandleElement.removeEventListener(
                "mouseup",
                this.OnDragHandleMouseUp.bind(this)
            );


            toDragHandleElement.removeEventListener(
                "mousemove",
                this.OnDragHandleMouseMove.bind(this)
            );


            if ((tempDragElement = document.getElementById("TempDragElement")) != null) {
                 tempDragElement.removeEventListener("mouseup", this.OnDragHandleMouseUp.bind(this));
            }

            //#endregion
        }

    };


    this.BindEvents = function () {
        let toDragHandleElement;
        let i;

        this.ContainerElement.setAttribute("HasBindListElementDraggerEvent", "true");

        for (i = 0; i < this.ToDragHandleElements.length; i++) {
            toDragHandleElement = this.ToDragHandleElements[i];

            //#region Remove Last Events
            toDragHandleElement.removeEventListener(
                "selectstart",
                this.OnDragHandleSelectStart.bind(this)
            );
            

            toDragHandleElement.removeEventListener(
                "mousedown",
                this.OnDragHandleMouseDown
            );


            toDragHandleElement.removeEventListener(
                "mouseup",
                this.OnDragHandleMouseUp.bind(this)
            );


            toDragHandleElement.removeEventListener(
                "mousemove",
                this.OnDragHandleMouseMove.bind(this)
            );
            //#endregion
            

            toDragHandleElement.addEventListener(
                "selectstart",
                this.OnDragHandleSelectStart.bind(this)
            );
 
            toDragHandleElement.addEventListener(
                "mousedown",
                this.OnDragHandleMouseDown.bind(this)
            );
            
             
            toDragHandleElement.addEventListener(
                "mouseup",
                this.OnDragHandleMouseUp.bind(this)
            );



            toDragHandleElement.addEventListener(
                "mousemove",
                this.OnDragHandleMouseMove.bind(this)
            );
             
        }

    };


    this.Detach = function () {
        this.Destroy();
    };

    this.OnDestroy = function () {
        this.Destroy();
    };

    this.Destroy = function () {

        Utility.RemoveArrayElement(
            ListElementDragger.AllDraggers ,
            this
        );

        delete this;
    }


}


ListElementDragger.AllDraggers = [];


ListElementDragger.ResetAll = function () {
    let listDragger;
    let i;

    for (i = this.AllDraggers.length - 1; i >= 0; i--) {
        listDragger = this.AllDraggers[i];

         if (listDragger.TargetListId != listDragger.TargetList.UniqueId) {
            debugger;
        }

        if (listDragger.ListElementContainerId != null) {
            if (document.querySelector(`[ListElementContainerId='${listDragger.ListElementContainerId}']`) == null) {
                Utility.RemoveArrayElement(this.AllDraggers, listDragger);
            }
        }
    }

    for (i = this.AllDraggers.length - 1; i >= 0; i--) {
        listDragger = this.AllDraggers[i];

        listDragger.ClearEvents();
        listDragger.Reset();
    }
}



ListElementDragger.DestroyAll = function () {
    let listDragger;
    let i;

    for (i = this.AllDraggers.length - 1; i >= 0; i--) {
        listDragger = this.AllDraggers[i];
        listDragger.Destroy();
    }

    this.AllDraggers.length = 0;
}



//Singleton
ListElementDragger.Instance = new ListElementDragger();

export default ListElementDragger;
